import React, { useState, useRef } from "react";
import {
  Card,
  Table,
  message,
  Form,
  Modal,
  InputNumber,
  Button,
  Row,
  Col,
  DatePicker,
  Select,
  Upload,
  Input,
  AutoComplete,
  Spin,
  Tooltip,
  Tag,
} from "antd";
import IntlMessages from "../../../util/IntlMessages";
import ds from "../../../Services/DataServices";
import { useHistory } from "react-router-dom";
import { useStore, useDispatch, useSelector } from "react-redux";
import { userLogOut } from "../../../appRedux/actions/Auth";
import { setCommonConfigs } from "../../../appRedux/actions/CommonData";
import { PRICEBOOK } from "../../../constants/Pages";
import {
  isEmptyObject,
  getRandomInt,
} from "../../../appRedux/actions/GlobalMethods";
import { BEHAVIOUR_TYPE } from "../../../Services/DataServices";
import {
  StringIsNullOrEmpty,
  getDecryptID,
  loadSearchSelectedProduct,
} from "../../../appRedux/actions";
import { stringify } from "querystring";
 

const DuplicatePriceBook = (params) => {
 
  const history  = useHistory();

  const [visible, setVisible] = React.useState(false);
  const priceBookID = params && params.PriceBookID;

  const showModal = () => {
    
    if(!StringIsNullOrEmpty(priceBookID)){
      setVisible(true);
    } else {
      message.error("Pricebook id should not be empty");
    }
  };
  const handleCancel = () => {
    setVisible(false);
  };

  const handleOk = () => {
    let postObj = {
      PriceBookID : priceBookID
    };
    postDuplicatePriceBookService(postObj, BEHAVIOUR_TYPE.POST);
  };
 
  async function postDuplicatePriceBookService(body, behaviorType) {
    try {
      const res = await ds.postDuplicatePriceBook(body, behaviorType);
  
      if (!res || !res.data) {
        throw new Error("Invalid response from server. Pricebook duplication failed.");
      }
  
      if (res.data.msgCode === "GENERAL_SUCCESS") {
        const duplicatePricebookURL = `/Dashboard/products/pricebook/customprices/${res.data.data.priceBookID}`;
        setVisible(false);
        message.success(res.data.data.message);
        setTimeout(() => {
              window.location.href =  duplicatePricebookURL;//  history.push(duplicatePricebookURL);
        }, 1000);
      } else {
        throw new Error("Pricebook is not duplicated. Something went wrong.");
      }
    } catch (error) {
      setVisible(false);
      message.error(error.message || "Pricebook is not duplicated. Something went wrong.");
    }
  }

  return (
    <>
      <div className="pg-header-btn">
        <Modal
          title={"Are you sure?"}
          visible={visible}
          onCancel={handleCancel}
          centered={true}
          className="ProductTags-Modal"
          footer={
            <>
              <Button
                className="dk-btn-cancel"
                type="primary"
                onClick={handleCancel}
              >
                Cancel
              </Button>
              <Button
                form="addATagForm"
                className="dk-btn-add"
                type="primary"
                onClick={handleOk}
              >
                Confirm
              </Button>
            </>
          }
        >
          <p style={{ fontWeight: "bold" }}>
            Duplicating your price book means that you cannot edit products
            until the process is complete.
          </p>

          <p>
            Duplicating your price book can take anything from a few moments to
            a few minutes, depending on the number of products it contains.{" "}
          </p>

          <p>
            During this time please ensure that you, or any other user, do not
            edit any product.{" "}
          </p>

          <p>
            Refresh the price book page and once the copy version is viewable,
            you are safe to edit again.
          </p>
        </Modal>

        <Button
          className="dk-btn-add"
          type="primary"
          onClick={showModal}
          size="large"
        >
          Duplicate PriceBook
        </Button>
      </div>
    </>
  );
};
export default DuplicatePriceBook;
